<template>
  <div>
    <button :class="btn_class" type="button" @click="toggle">
      <i class="fa fa-plus" /> &nbsp;&nbsp;
      {{ $t('employee-group.add-from-employees-list') }}
    </button>

    <div :class="show ? 'is-active' : ''" class="modal">
      <div class="modal-background" @click="toggle" />
      <div class="modal-card" style="min-height: 60vh; width: 95%">
        <header class="modal-card-head">
          <p
            class="modal-card-title"
            v-text="$t('employee-group.search-for-employee')"
          />
          <button class="delete" aria-label="close" @click="toggle" />
        </header>
        <section class="modal-card-body" style="min-height: 200px">
          <div
            v-show="flash_success"
            class="notification is-success"
            v-html="$t('employee-group.added-to-group-successfully')"
          />
          <input v-model="filters.search" :placeholder="$t('employee-group.search-for-employee')" class="input" autocomplete="off">
          <div v-if="filteredEmployees.length">
            <br>
            <small><i class="fa fa-exclamation-circle color-is-warning"></i> <em>{{ $t('employee-group.check-box-employees') }}</em></small>
              <b-table
                :hoverable="true"
                :striped="true"
                :total="total"
                :narrowed="true"
                :data="filteredEmployees"
                :checked-rows.sync="checked_employees"
                paginated
                checkable
                :per-page="perPage"
                :current-page="page"
                backend-pagination
                @page-change="onPageChange"
              >
                <b-table-column v-slot="props" field="index" label="#">
                  {{ (props.index+1) + ((page - 1) * perPage) }}.
                </b-table-column>
                <b-table-column v-for="(column) in columns" :key="column['field']" v-slot="props" :label="column['label']">
                  <small>{{ props.row[column['field']] }}</small>
                </b-table-column>
              </b-table>
          </div>
        </section>
        <footer class="modal-card-foot">
          <div class="level is-full-width">
            <div class="level-left">
              <button
                class="button"
                @click="toggle"
                v-text="$t('employee-group.search-close-button')"
              />
              <b-button
                label="Clear checked"
                type="is-danger"
                icon-left="close"
                class="field is-block"
                @click="checked_employees = []" />
            </div>
            <div class="level-right">
              <b>Employees selected</b>: {{ checked_employees.length }}
              <button
                class="ml-1 button is-success"
                @click="add"
                v-text="$t('employee-group.search-add-button')"
              />
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { map, debounce, find } from 'lodash';
import EmployeesApi from 'api/employees';

export default {
  name: 'AddFromEmployeesList',

  props: {
    employees_list: { type: Array, required: true }, //v-model variable
    btn_class: {
      type: String,
      default: 'button is-outlined is-primary is-medium is-fullwidth'
    }
  },

  data() {
    return {
      checked_employees: [],
      columns: [
        { field: 'name', label: 'Name' },
        { field: 'email', label: 'Email' },
        { field: 'country', label: 'Country' },
        { field: 'division', label: 'Division' },
        { field: 'department', label: 'Department' },
        { field: 'position', label: 'Position' }
      ],
      show: false,
      flash_success: false,
      isLoading: false,
      employee: null,
      filteredEmployees: [],
      employees: this.employees_list,
      employeesApi: new EmployeesApi(),
      filters: this.getDefaultFilters(),
      pagination_total: 0,
      page: 1,
      perPage: 100
    };
  },

  watch: {
    'filters.search'(val) {
      if (val.length >= 1 || val === '') {
        this.search();
      }
    }
  },

  created() {
    VueEventHub.$on('employee-added-to-list', this.flashSuccessMessage);
  },

  methods: {
    onPageChange(page) {
      this.page = page;
      this.queryEmployees();
    },

    toggle() {
      this.show = !this.show;
      this.checked_employees = [];
      this.filters = this.getDefaultFilters();
      this.queryEmployees();
      this.page = 1;
    },

    flashSuccessMessage() {
      this.flash_success = true;
      setTimeout(() => {
        this.flash_success = false;
      }, 2000);
    },

    search: debounce(function search() {
      if (this.filters.search || this.filters.search === '') {
        this.isLoading = true;
        this.page = 1;
        this.queryEmployees();
      } else {
        this.filteredEmployees = [];
      }
    }, 500),

    queryEmployees() {
      this.employeesApi
        .search(this.filters.search, map(this.employees, 'id'), this.page)
        .then(response => {
          const currentTotal = response.meta.pagination.total;
          this.total = currentTotal;
          this.filteredEmployees = response.data;
        })
        .catch(() => {});
    },

    add() {
      if (this.checked_employees.length) {
        this.checked_employees.forEach(
          user => {
            if (!find(this.employees, { id: user.id })) {
              this.employees.push(user);
            }
          }
        );
        VueEventHub.$emit('add-employees', this.checked_employees);
      }
      this.toggle();
    },

    getDefaultFilters() {
      return { search: '' };
    },

    mounted() {
      this.queryEmployees();
    }
  }
};
</script>
